// Per-filler "recent clients" quick-pick, mirroring
// manifold-pwa/src/utils/recentClients.js. Namespaced per-username like
// fillingQueue.js so a shared device never mixes one filler's recents into
// another's suggestions.
const KEY_PREFIX = 'mm_cra_recent_clients_';
const MAX_RECENTS = 5;

const key = (username) => `${KEY_PREFIX}${username}`;

export function loadRecentClients(username) {
  if (!username) return [];
  try {
    const raw = localStorage.getItem(key(username));
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

// Moves `client` to the front (deduping) and caps the list — call whenever a
// filling is saved so the most-recently-used clients surface first.
export function recordRecentClient(username, client) {
  if (!username || !client) return;
  const next = [client, ...loadRecentClients(username).filter((c) => c !== client)].slice(0, MAX_RECENTS);
  localStorage.setItem(key(username), JSON.stringify(next));
}
